// extracted by mini-css-extract-plugin
export default {"button":"Nk-z","reviewSort":"Ok-z"};